// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"c1b39c82","94":"4ab7e948","100":"0b720d9d","224":"01c62e79","287":"57c2473d","317":"7adcb720","453":"4cf4af69","468":"28bb1a74","528":"aa44735e","627":"91b9b4d1","968":"916daea5"}[chunkId] + ".chunk.css";
};